module.exports = __webpack_public_path__ + "2-easter-snow.cfffaa1fe6bed9097fab.png";


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/assets/images/festival/2-easter-snow.png
// module id = ../../../../../src/assets/images/festival/2-easter-snow.png
// module chunks = styles